<template>
  <div v-if="loaded" class="project-layout">
    <app-header>
      <template #title>
        <stage-selector v-if="project.client" :project="project" :stage="{}"></stage-selector>
      </template>
    </app-header>

    <div class="layout-sidesheet row">
      <div class="col main-content d-flex flex-column">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>

    import { findIndex, find } from 'lodash'
    import { mapActions, mapState } from 'vuex'
    import StageSelector from './_stage-selector'
    import SettingsModalStage2 from './project/stage2/SettingsModal'

    var project = require('./../../models/project.js');

    export default {
        components: {
            StageSelector,
            SettingsModalStage2
        },

        data: function () {
            return {
                loaded: false
            }
        },

        computed: {
            ...mapState('yodizproject', {project: 'single'}),

            otherMembers () {
              return this.members.filter((item) => {
                return item.id !== this.$user.id;
              })
            },

            presenceChannelName () {
                return `channel-${this.$route.params.project_id}`
            },

            showSubMenu () {
                return find(this.$route.matched, ['name', 'projects.show.stage2']) != undefined
            },

            subMenuTitle () {
                if (this.$route.name == 'projects.show.stage2.userstories') {
                    return 'User Stories'
                } else if (this.$route.name == 'projects.show.stage2.deliverables') {
                    return 'Deliverables'
                } else if (this.$route.name == 'projects.show.stage2.schedule') {
                    return 'Schedule'
                } else if (this.$route.name == 'projects.show.stage2.quotes') {
                    return 'Quotes'
                }

                return ''
            },

            modalComponentForRoute() {
                if (find(this.$route.matched, ['name', 'projects.show.stage2']) != undefined) {
                    return 'settings-modal-stage2'
                }

                return ''
            }
        },
        mounted() {
           this.loadData()
        },
        watch: {
            '$route.params.project_id': function(newId, oldId) {
                this.loaded = false
                this.loadData()
            }
        },
        methods: {
            ...mapActions('yodizproject', {getProject: 'getSingle'}),

        	getAvatar: function(id) {
        		return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar';
            },

            async loadData () {
                await this.getProject(this.$route.params.project_id)
                this.loaded = true
            }
        },

    }
</script>
